import { faEye } from '@fortawesome/free-regular-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import Tran_data_unlock_request from '../Tran_data_unlock_request';


const Expense_tran = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');

    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [headerData, setHeaderData] = useState([]);

    const [locationValue, setLocationValue] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [location, setLocation] = useState('');
    const [locationGroup, setLocationGroup] = useState('0');
    const [locationLedger, setLocationLedger] = useState('0');

    const [expNewDate, setExpNewDate] = useState(new Date());
    const [expFromDate, setExpFromDate] = useState(new Date());
    const [expToDate, setExpToDate] = useState(new Date());
    const [radioType, setRadioType] = useState('N');
    const [expFromSrno, setExpFromSrno] = useState('');
    const [expToSrno, setExpToSrno] = useState('');

    const [expInnerDate, setExpInnerDate] = useState(new Date());
    const [ledgerValue, setLedgerValue] = useState(null);
    const [grpCode, setGrpCode] = useState('0');
    const [accCode, setAccCode] = useState('0');
    const [accountType, setAccountType] = useState('');
    const [accountName, setAccountName] = useState('');
    const [narration, setNarration] = useState('');

    const [dataList, setDataList] = useState([]);

    const [branchValue, setBranchValue] = useState(null);
    const [branchCode, setBranchCode] = useState(0);
    const [branch, setBranch] = useState('');
    const [branchGroup, setBranchGroup] = useState('0');
    const [branchLedger, setBranchLedger] = useState('0');

    const [flag, setFlag] = useState('D');
    const [detailAmount, setDetailAmount] = useState('');

    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [key, setKey] = useState("DETAIL");

    const [counter, setCounter] = useState(0);

    const [srNo, setSrNo] = useState(0);

    const [totalDebit, setTotalDebit] = useState(0);
    const [totalCredit, setTotalCredit] = useState(0);
    const [totalDifference, setTotalDifference] = useState(0);

    const [viewDate, setViewDate] = useState('');

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", trancategory: "", tranDate: "" });

    const currentDate = new Date();

    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [showFaView, setShowFaView] = useState(false);
    const [tranAuditTrail, setTranAuditTrail] = useState([]);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [showActivityLog, setShowActivityLog] = useState(false);

    const [unlockRequestType, setUnlockRequestType] = useState("");
    const [isBranchDisableForAddNew, setIsBranchDisableForAddNew] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setLocationValue(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_EXPENSE'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setLocationValue(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        setLocationGroup(loc[6]);
        setLocationLedger(loc[7]);
        sessionStorage.activeBranch = loc[1];
        setIsBranchDisableForAddNew(loc[9]);
    }

    const handleChangeBranch = (value) => {
        setBranchValue(value);
        const loc = value.id.split('^');
        setBranchCode(loc[1]);
        setBranch(loc[2]);
        setBranchGroup(loc[6]);
        setBranchLedger(loc[7]);
    }

    const addNew = () => {
        var i = 0, msg = [];
        var date = Common.dateYMD(expNewDate);
        var today = Common.dateYMD(new Date());
        if (!locationValue || !expNewDate) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!locationValue ? " Select location." : '');
            msg[i++] = (!expNewDate ? " Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else if (date > endDate || date < startDate) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0010"));
        } else if (date > today) {
            setMsgBox(true);
            setMsgText(Common.getMessage("MSG0011"));
        }
        else if (+isBranchDisableForAddNew === 1) {
            setMsgBox(true);
            setMsgText("Branch Disable .New Entry not Allowed.");
        }
        else {
            if (date == today) {
                addNewFormResetFields();
            } else {
                const obj = {
                    billdate: date,
                    location: locationCode,
                    type: 'ET'
                }
                Common.callApi(Common.apiDataUnlock, [sid, 'addnewunlock', JSON.stringify(obj)], result => {
                    let resp = JSON.parse(result);
                    if (resp.msg === "1") {
                        addNewFormResetFields();
                    } else {
                        setMsgBox(true);
                        setMsgText(Common.getMessage("MSG0012"));
                    }
                });
            }
        }
    }

    const addNewFormResetFields = () => {
        setScrMode('A');
        setDataList([]);
        setLedgerValue(null);
        setDetailAmount('');
        setNarration('');
        setSrNo(0);
        setKey("DETAIL");
        setBranchValue(null);
        setBranchCode(0);
        setBranch('');
        // const d = expNewDate;
        // const formatted = 
        //     String(d.getDate()).padStart(2, '0') + '/' +
        //     String(d.getMonth() + 1).padStart(2, '0') + '/' +
        //     d.getFullYear();
        // setViewDate(formatted);
    }

    const list = () => {
        var i = 0, msg = [];
        if (!locationValue || (radioType === 'S' && !expFromSrno) || (radioType === 'S' && !expToSrno) || (radioType === 'D' && !expFromDate) || (radioType === 'D' && !expToDate)) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!locationValue ? " Select location." : '');
            msg[i++] = ((radioType === 'S' && !expFromSrno) ? " From Srno." : '');
            msg[i++] = ((radioType === 'S' && !expToSrno) ? " To Srno." : '');
            msg[i++] = ((radioType === 'D' && !expFromDate) ? " From Date." : '');
            msg[i++] = ((radioType === 'D' && !expToDate) ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                hdr_location: locationCode,
                hdr_type: 'ET',
                fromSrno: expFromSrno,
                toSrno: expToSrno,
                fromDate: Common.dateYMD(expFromDate),
                toDate: Common.dateYMD(expToDate),
                radioType: radioType
            }
            $(".loader").show();
            Common.callApi(Common.apiExpenseTrans, [sid, 'showHeaderEntry', JSON.stringify(obj)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setHeaderData(resp);
            })
        }
    }

    const handleTabChange = (k) => {
        setKey(k);
    }


    const handleLedgerValue = (value) => {
        setLedgerValue(value);
        console.log(value);
        console.log("full id:", value.id);          
        console.log("split:", value.id.split('^')); 
        const account = value.id.split('^');
        setGrpCode(account[3]);
        setAccCode(account[4]);
        setAccountType(account[5]);
        setAccountName(account[1]);
    }

    const handleBack = () => {
        setScrMode('');
    }

    const handleSave = () => {
        if (narration == "") {
            setMsgText("Please fill Remark.");
            setMsgBox(true);
        }
        if (!ledgerValue || !detailAmount) {
            setMsgText("Please fill all mandatory fields.");
            setMsgBox(true);
        }
        
        else {
            const obj = {
                    hdr_location: locationCode,
                    hdr_date: Common.dateYMD(expNewDate),
                    hdr_group: grpCode,
                    hdr_ledger: accCode,
                    dataList: dataList,
                    hdr_type: 'ET',
                    fromSrno: expFromSrno,
                    toSrno: expToSrno,
                    fromDate: Common.dateYMD(expFromDate),
                    toDate: Common.dateYMD(expToDate),
                    radioType: radioType,
                    hdr_narration: narration,
                    srNo: srNo,
                    hdr_total: totalDifference,
                    hdr_location_group: locationGroup,
                    hdr_location_ledger: locationLedger,
                    viewDate: viewDate,
                    Amount: detailAmount
            }
            $(".loader").show();
            Common.callApi(Common.apiExpenseTrans, [sid, 'saveEntry', JSON.stringify(obj), JSON.stringify(tranAuditTrail)], result => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                setHeaderData(resp);
                setScrMode('');
                setTranAuditTrail([]);
            })
            if (scrMode == 'E' && unlockRequestType !== "SELF") {
                const obj = {
                    srno: srNo,
                    type: 'ET',
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'EXPENSE_TRAN'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(obj)], (result) => {
                    console.log(result);
                })
            }
        }
    }

    const handleDetailAdd = () => {
        var i = 0, msg = [];
        if (!detailAmount ) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (!detailAmount ? " Amount." : '');
            msg[i++] = (locationCode == branchCode ? "You can't select same branch." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                uniquekey: Common.getRandomString(15),
                td_location: locationCode,
                td_location_name: location,
                td_flag: flag,
                td_amount: flag == 'C' ? -1 * detailAmount : detailAmount,
                td_group: branchCode,
                td_ledger: branchLedger,
                delny: 'Y',
            }
            setDataList(Common.arrayAddItem(dataList, obj));
            const obj2 = {
                TabType: "Detail",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                TLoc: locationCode,
                TType: 'ET',
                LocationName: location,
                Flag: flag,
                Amount: flag == 'C' ? -1 * detailAmount : detailAmount,
                Group: grpCode,
                Ledger: accCode,
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, obj2]);
            }
            calculateTotal(dataList)
            setCounter(counter + 1);
            setFlag('D');
            // setDetailAmount('');
            setBranchValue(null);
            console.log(dataList);

        }
    }

    const calculateTotal = (list) => {
        let totalDebt = 0;
        let totalCred = 0;
        let i;
        for (i = 0; i < list.length; i++) {
            if (list[i].td_flag == 'D') {
                totalDebt = totalDebt + list[i].td_amount * 1;
            } else {
                totalCred += list[i].td_amount * -1;
            }
        }
        setTotalDebit(totalDebt);
        setTotalCredit(totalCred);
        let totalDiff = totalDebt - totalCred;
        setTotalDifference(parseFloat(totalDiff.toFixed(2)));
        if (totalDiff < 0) {
            setFlag('D');
            setDetailAmount(-1 * totalDiff);
        }
        else {
            setFlag('C');
            setDetailAmount(totalDiff);
        }
    }

    const handleView = (srno, type, loc, date, grp, ledger, narration, loc_name,amount,ledgerLoc) => {
        console.log("date param:", date);
        console.log("viewDate after set:", viewDate); 
        setLocation(loc_name)
        setNarration(narration);
        setViewDate(date);
        setSrNo(srno);
        setDetailAmount(amount)
        setGrpCode(grp);   
        setAccCode(ledger);
        setLedgerValue(ledgerLoc);
        console.log("ledgerLoc",ledgerLoc);

        const obj = {
            srno: srno,
            type: type,
            date: date,
            location: loc,
            group: grp,
            ledger: ledger
        }
        $(".loader").show();
        Common.callApi(Common.apiExpenseTrans, [sid, 'viewDataList', JSON.stringify(obj)], result => {
            $(".loader").hide();    
            let resp = JSON.parse(result);
            console.log("resp",resp);
            setLedgerValue( {label: resp.ledger_location, id: resp.ledger_location});
            setGrpCode(grp);    
            setAccCode(ledger);
            setDataList(resp.resarray);
            calculateTotal(resp.resarray);
            setScrMode('Q');
            setDetailAmount(resp.amount);  
        })
    }

    const handleDelete = (val, loc, type, srno, lineno) => {
        const itemToDelete = dataList.find(item => item.uniquekey === val);
        if (itemToDelete) {
            const formattedItem = {
                TabType: "Detail",
                ALineNo: tranAuditTrail.length + 1,
                AType: "D",
                TLoc: locationCode,
                TType: 'ET',
                LocationName: itemToDelete.td_location_name,
                Flag: itemToDelete.td_flag,
                Amount: itemToDelete.td_amount,
                Group: itemToDelete.td_group,
                Ledger: itemToDelete.td_ledger,
            }
            if (userRight.edit === "1" && scrMode === 'E') {
                setTranAuditTrail(prevtranAuditTrail => [...prevtranAuditTrail, formattedItem]);
            }
        }
        setDataList(Common.arrayRemoveItem(dataList, "uniquekey", val));
        setCounter(counter - 1);
        console.log(dataList);
        calculateTotal(dataList)
    }

    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = viewDate.split('/');

        const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newDate);
        const dateB = new Date(newCurrDate);

        const differenceInMilliseconds = dateB - dateA;
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        const obj = {
            srno: srNo,
            type: 'ET',
            pageright: 'EXPENSE_TRANSFER',
            location: locationCode
        }
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setScrMode('E');
            } else {
                setShowEditRequest(true);
                setEditLogObject({ trantype: 'ET', trannumber: srNo, location: locationCode, tranDate: Common.dateYMD(currDate) });
            }
        })
    }

    const handleFaView = () => {
        setShowFaView(true);
        setFaViewObject({ location: locationCode, trannumber: srNo, type: 'ET'  });
    }

    const handleInnerFaView = (srno, type, loc) => {
        setShowFaView(true);
        setFaViewObject({ location: loc, trannumber: srno, type: type });
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "ET", trannumber: srNo, trancategory: "T", location: locationCode });
    }

    const handleExpanceTransferPrint = (printFlag) => {
        $(".loader").show();
        const obj = {
            srno: srNo,
            location: locationCode,
            faType: 'ET',
            printFlag: printFlag,
            type: 'FAP',
        }
        Common.callApi(Common.apiPrint, [sid, "print", JSON.stringify(obj)], result => {
            $(".loader").hide();
            var newWindow = window.open();
            newWindow.document.write(result);
        });
    }

    return (
        <div>
            <LoginHeader />
            <Menu />

            <Container fluid>
                <Row>
                    <Col>
                        <h2>Expense <span style={{ color: 'white' }}></span></h2>
                    </Col>
                </Row>&nbsp;
                {
                    scrMode == '' ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={true}
                                            value={locationValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            // onChange={handleChangeBranch}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "N"} onChange={() => setRadioType("N")} type='radio' label="New" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>&nbsp;

                            <Row>
                                {
                                    radioType === 'N' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>Date<span className="text-danger">*</span></Form.Label>
                                                    <DatePicker className="form-control"
                                                        selected={expNewDate}
                                                        minDate={new Date(startDate)}
                                                        maxDate={new Date(endDate)}
                                                        onChange={(date) => setExpNewDate(date)}
                                                        dateFormat="dd/MM/yyyy"
                                                        showYearDropdown
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        dropdownMode="select"
                                                        peekNextMonth
                                                        customInput={
                                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                        }
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </>
                                        :
                                        radioType === 'S' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control value={expFromSrno}
                                                            maxLength={20}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setExpFromSrno)}
                                                            placeholder="From" />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                        <Form.Control value={expToSrno}
                                                            maxLength={20}
                                                            onChange={(e) => Common.validateNumValue(e.target.value, setExpToSrno)}
                                                            placeholder="To" />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            radioType === 'D' ?
                                                <>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={expFromDate}
                                                                onChange={(date) => setExpFromDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className='col-md-3 col-6'>
                                                        <Form.Group>
                                                            <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={expToDate}
                                                                onChange={(date) => setExpToDate(date)}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth
                                                                customInput={
                                                                    <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                                :
                                                null
                                }
                            </Row>&nbsp;

                            <Row>
                                <Col>
                                    {
                                        radioType === 'N' ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => addNew()}>Add New</Button> : null
                                    }
                                    &nbsp;
                                    {
                                        (radioType === 'S' || radioType === 'D') ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => list()}>List</Button>
                                            : null
                                    }
                                </Col>
                            </Row>&nbsp;

                            {headerData.length > 0 &&
                                <Row>
                                    <Col>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    <th>&nbsp;</th>
                                                    <th>Sr No</th>
                                                    <th>Location</th>
                                                    <th>Type</th>
                                                    <th>Date</th>
                                                    <th>Ledger</th>
                                                    <th>Amount</th>
                                                </tr>
                                            </thead>
                                            {
                                                headerData.map((res) =>
                                                    <tbody>
                                                        <tr key={res.hdr_srno}>
                                                            <td>
                                                                <span className='pointer colorThemeBlue' onClick={() => handleView(res.hdr_srno, res.hdr_type, res.hdr_location, res.formatted_date, res.hdr_group, res.hdr_ledger, res.hdr_remark1, res.entity_name ,res.hdr_usd_amount,res.ledger_location)}>
                                                                    <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                                </span>
                                                            </td>
                                                            <td>{res.hdr_srno}</td>
                                                            <td>{res.entity_name}</td>
                                                            <td>{res.hdr_type}</td>
                                                            <td>{res.formatted_date}</td>
                                                            <td>{res.ledger}</td>
                                                            <td>{res.hdr_usd_amount}</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                            }
                                        </Table>
                                    </Col>
                                </Row>
                            }
                        </> :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-success' className='buttonStyle' size='sm'
                                        onClick={handleBack}
                                    >Back</Button>{' '}

                                    {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    }
                                    {(userRight.edit === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    }

                                    {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm'
                                                onClick={handleSave}
                                            >Save</Button> : null
                                    }
                                    {
                                        (userRight.query === "1" && scrMode === "Q") ? <>
                                            {/* <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp; */}
                                            {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => handleExpanceTransferPrint("P")}>Print</Button>&nbsp; */}
                                        </> : null
                                    }
                                </Col>
                            </Row>&nbsp;

                            <Row>
                                <Col>
                                    <Form.Label>Sr No : {srNo}</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Label>Date : {scrMode === 'A' ? Common.dateDMY(expNewDate) : viewDate}</Form.Label>
                                </Col>
                                <Col>
                                    <Form.Label>Location : {locationCode} {location}</Form.Label>
                                </Col>&nbsp;
                                {/* <Col>
                                    <Form.Label>{totalDifference < 0 ? 'Debit Amount' : 'Credit Amount'}  : {totalDifference < 0 ? -1 * totalDifference : totalDifference}</Form.Label>
                                </Col> */}
                            </Row>

                            <Row>
                                {/* <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Date<span className="text-danger">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={expNewDate}
                                            minDate={new Date(startDate)}
                                            maxDate={new Date(endDate)}
                                            onChange={(date) => setExpNewDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col> */}
                                {/* <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Account</Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={ledgerValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, 1)} // location = 1 , 2
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLedgerValue}
                                            isDisabled={scrMode === 'Q' && true}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col> */}
                            </Row>&nbsp;

                            <Row>
                                {/* <Col>
                                    <Form.Group>
                                        <Form.Label>Remark<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            value={narration}
                                            maxLength={999}
                                            as="textarea"
                                            placeholder="Leave a comment here"
                                            style={{ height: '100px' }}
                                            onChange={(e) => setNarration(e.target.value)}
                                            disabled={scrMode === 'Q'}
                                        />
                                    </Form.Group>
                                </Col> */}
                            </Row>&nbsp;

                            {
                                <>
                                <Row>
                                {/* <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Date<span className="text-danger">*</span></Form.Label>
                                        <DatePicker className="form-control"
                                            selected={expNewDate}
                                            minDate={new Date(startDate)}
                                            maxDate={new Date(endDate)}
                                            onChange={(date) => setExpNewDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                            <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col> */}
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Expense</Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={ledgerValue}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={(search) => Picklist.expensePicklist(search)} 
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleLedgerValue}
                                            isDisabled={scrMode === 'Q' && true}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                        {/* <Col className='col-md-3 col-6'>
                                            <<Form.Group></Form.Group>
                                                <Form.Label>Branch<span className="text-danger">*</span></Form.Label>
                                                <AsyncSelect
                                                    cacheOptions={false}
                                                    defaultOptions={false}
                                                    value={branchValue}
                                                    getOptionLabel={e => e.label + ' '}
                                                    getOptionValue={e => e.id}
                                                    loadOptions={Picklist.fetchLocationPicklist}
                                                    onInputChange={Picklist.handleInputChange}
                                                    onChange={handleChangeBranch}
                                                >
                                                </AsyncSelect>
                                            </Form.Group>
                                        </Col> */}

                                        <Col className='col-md-3 col-6'>
                                            <Form.Group>
                                                <Form.Label>Amount</Form.Label>
                                                <Form.Control
                                                    value={detailAmount}
                                                    maxLength={Common.maximumLength}
                                                    onChange={(e) => Common.validateDecValue(e.target.value, setDetailAmount)}
                                                    placeholder="Amount"
                                                    disabled={scrMode === 'Q' }
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col>
                                            <Button variant='outline-primary' className='buttonStyle' size='sm'
                                                onClick={handleDetailAdd}
                                            >Add</Button>
                                        </Col>
                                    </Row> */}
                                    <Row>&nbsp;</Row>
                                </>
                            }

                            {/* { dataList.length > 0 &&
                                <Row>
                                    <Col>
                                        <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                    {userRight.delete === "1" || userRight.edit === "1" ? <th></th> : null}
                                                    <th>Location</th>
                                                    <th style={{ textAlign: 'right' }}>Credit</th>
                                                    <th style={{ textAlign: 'right' }}>Debit</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dataList.map((res) =>
                                                    <tr key={res.td_line_no}>
                                                        {userRight.delete === "1" || userRight.edit === "1" ?
                                                            <td className="textCenter " >
                                                                {
                                                                    scrMode === 'Q' || res.delny === 'N' ? null :
                                                                        <>
                                                                            <span className="handCursor colorThemeBlue"
                                                                                onClick={() => handleDelete(res.uniquekey, res.td_location, res.td_type, res.td_srno, res.td_line_no)}>
                                                                                <FontAwesomeIcon icon={faTrash} />
                                                                            </span>{' '}
                                                                        </>
                                                                }
                                                                {
                                                                    scrMode === 'Q' ?
                                                                        <span className='pointer colorThemeBlue' onClick={() => handleInnerFaView(res.td_srno, res.td_type, res.td_location)}>
                                                                            <FontAwesomeIcon icon={faEye} />
                                                                        </span>
                                                                        : null
                                                                }
                                                            </td>
                                                            : null
                                                        }
                                                        <td>{res.td_location_name}</td>
                                                        <td style={{ textAlign: 'right' }}>{res.td_flag == "C" && -1 * res.td_amount}</td>
                                                        <td style={{ textAlign: 'right' }}>{res.td_flag == "D" && res.td_amount}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </Col>
                                </Row>
                            } */}

                            <hr />
                            <Row>
                            <Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Remark<span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            value={narration}
                                            maxLength={999}
                                            as="textarea"
                                            placeholder="Leave a comment here"
                                            style={{ height: '100px' }}
                                            onChange={(e) => setNarration(e.target.value)}
                                            disabled={scrMode === 'Q'}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>&nbsp;
                                {/* <Col> */}
                                    {/* <Button variant='outline-success' className='buttonStyle' size='sm'
                                        onClick={handleBack}
                                    >Back</Button>{' '} */}

                                    {/* {
                                        (userRight.edit === "1" && scrMode === 'Q') ? <>
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                btnEditRequest()}>Edit</Button>&nbsp;
                                        </> : null
                                    } */}
                                    {/* {(userRight.edit === "1" && scrMode === 'Q') ? <>
                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                    </> : null
                                    } */}

                                    {/* {
                                        (userRight.edit === "1" && scrMode === 'E') || (userRight.add === "1" && scrMode === 'A') ?
                                            <Button variant='outline-success' className='buttonStyle' size='sm'
                                                onClick={handleSave}
                                            >Save</Button> : null
                                    } */}
                                    {/* {
                                        (userRight.query === "1" && scrMode === "Q") ? <>
                                            <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={() => handleFaView()}>Fa View</Button>&nbsp;
                                            <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => handleExpanceTransferPrint("P")}>Print</Button>&nbsp;
                                        </> : null
                                    } */}
                                    {/* {
                                        (userRight.query === "1")
                                    } */}
                                {/* </Col> */}
                            </Row>&nbsp;
                        </>
                }

            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />

            <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} onHide={() => setShowEditRequest(false)} />

            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </div >

    )
}

export default Expense_tran;